import { onBeforeUnmount, onMounted, ref } from 'vue';

/**
 * Tracks whether the viewport height is below the threshold at which the rail
 * cannot fit both its top and bottom blocks. When `overflow` is true the
 * organism collapses the bottom block under a "More" overflow trigger.
 *
 * Threshold matches Figma's note: nav overflow activates at heights below 882px.
 */
export function useNavOverflow(thresholdPx = 882) {
  const overflow = ref(false);

  function measure() {
    if (typeof window === 'undefined') return;
    overflow.value = window.innerHeight < thresholdPx;
  }

  onMounted(() => {
    measure();
    window.addEventListener('resize', measure);
  });

  onBeforeUnmount(() => {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', measure);
    }
  });

  return { overflow };
}

export default useNavOverflow;
